/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import CreateAudit from "../../Components/Steps/CreateAudit";
import Step3 from "../../Components/Steps/Step3AuditorTeam";
import Step2 from "../../Components/Steps/Step2AuditTheme";
import Step4 from "../../Components/Steps/Step4AuditPreference";
import Step5 from "../../Components/Steps/Step5ReviewandSubmit";
import Step1 from "../../Components/Steps/step1AuditeeOrganization";
import { getAIcomplaince } from "../../api/common";
import { AuditOption } from "../../commonTypes";
import AuditTheme from "../../icons/Audit Theme.svg?react";
import AuditeeInfo from "../../icons/auditeeInfo.svg?react";
import config from "../../icons/config.svg?react";
import Review from "../../icons/review.svg?react";
import Users from "../../icons/users.svg?react";
import { getDaysDiff, parseDate } from "../../utils";
import "./style.scss";
import { useDispatch } from "react-redux";
import { setSelectedMembers, setSelectedThemes } from "../../reducers/Audit";
import { setMappedBanksvalues } from "../../reducers/bankSlice";
import { AUDIT_LEVEL, AUDIT_MODES } from "../../constants";
interface TeamMember {
  id: string;
  name: string;
  email: string;
}

interface AuditeMember {
  email: string;
  name: string;
  memberId: string;
  role: string;
}
interface Teamlead {
  email: string;
  name: string;
  memberId: string;
  role: string;
}
interface OrganizationDetail {
  organizationId: number;
  name: string;
  type: string;
  applicationName: string;
  organizationEmail: string;
  teamLead: Teamlead[];
  members: AuditeMember[];
  logo?: string;
  createdBy?: string | null;
  createdDate?: Date | null;
  mappedAt?: Date;
  modifiedBy?: string | null;
  modifiedDate?: Date | null;
}
export interface AuditData {
  teamMembers: TeamMember[];
  auditLevel: number;
  auditType: number;
  auditSla: number;
  escalationDay: number;
  kickOffMeeting: boolean;
  auditeeInfo: {
    membersname?: string[];
    membersmail?: string[];
    applicationName?: string[];
    auditThemeNames?: string[];
    organizationdetail?: OrganizationDetail[];
    organizationDetailsData?: {
      orgId: number;
      applicationId: number[];
      auditeeMembers: { memberId: number; role: string }[];
      auditeeTeamLead: { memberId: number; role: string }[];
    }[];
    sequencedata?: any[];
    members: TeamMember[];
    applicationID: number[];
    startDate: Date;
    startDateMarker: Date;
    endDate: Date;
    endDateMarker: Date;
    auditee: string;
    emails: AuditeMember[];
    organizations: AuditeMember[];
    auditThemes: AuditeMember[];
    auditScope: string;
    applicationDesc: string;
    auditeeTeamLead: Teamlead[];
    isTeamLead?: boolean;
  };
}
interface StateProps {
  userData: any;
  membersList: any;
  auditTypeList: any;
  auditeesList: any;
  auditUpdatedata: any;
  sequence: any;
  getTheme: any;
  getOrganization: any;
  loading: boolean;
  showToast: boolean;
  onSubmit: (data: AuditData) => void;
}

const AuditRegistration: React.FC<StateProps> = ({
  userData,
  membersList,
  loading,
  showToast,
  auditeesList,
  getOrganization,
  getTheme,
  auditUpdatedata,
  sequence,
  onSubmit,
}) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [teamMembersDisplay, setTeamMembersDisplay] = useState<string[]>();
  const [auditeeDisplay, setAuditeeDisplay] = useState<string>("");
  const [aiobservation, setaiobservation] = useState<any[]>([]);
  const [showAIobservation, setShowAIobservation] = useState(false);
  const [showAItooltip, setShowAItooltip] = useState(false);
  const [showAISuggestion, setShowAISuggestion] = useState(false);
  const [AIloading, setAIloading] = useState(false);
  const [showAICompanion, setShowAICompanion] = useState(false);
  const [aiSuggestion, setaiSuggestion] = useState<any[]>([]);
  const [aiContextHistory, setAiContextHistory] = useState<
    { contextName: string; payload: any }[]
  >([]);
  const [accumulatedAIPayload, setAccumulatedAIPayload] = useState<
    Record<string, any>
  >({});

  const dispatch = useDispatch();
  const [auditData, setAuditData] = useState<AuditData>({
    teamMembers: [],
    auditLevel: 1,
    auditType: 0,
    auditSla: 0,
    escalationDay: 0,
    kickOffMeeting: false,
    auditeeInfo: {
      sequencedata:
        sequence?.map((item: any, index: any) => ({
          sequenceId: item.sequenceId,
          sequenceOrder: index + 1,
        })) ?? [],
      applicationID: [],
      members: [],
      organizations: [],
      auditThemes: [],
      auditeeTeamLead: [],
      startDate: new Date(),
      startDateMarker: new Date(),
      endDate: new Date(),
      endDateMarker: new Date(),
      auditee: "",
      emails: [],
      auditScope: "",
      applicationDesc: "",
    },
  });

  const [auditMembers, setAuditMembers] = useState<any>([]);
  const [selectedMembersOption, setSelectedMembersOption] = useState<any>([]);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [validated, setValidated] = useState(false);
  const [submitClicked, setSubmitClicked] = useState(false);
  const [checked, setChecked] = useState(false);
  const [sequenceMode, setSequenceMode] = useState<"default" | "custom">(
    "default",
  );
  const [customSequenceOrder, setCustomSequenceOrder] = useState<any[]>(
    sequence || [],
  );

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked;
    setChecked(value);
    setAuditData((prev) => ({
      ...prev,
      kickOffMeeting: value,
    }));
  };

  const steps = [
    { number: 1, title: "Auditee Organization", icon: Users },
    { number: 2, title: "Audit Theme", icon: AuditTheme },
    { number: 3, title: "Auditor Team", icon: AuditeeInfo },
    { number: 4, title: "Audit Preference", icon: config },
    { number: 5, title: "Review and Submit", icon: Review },
  ];

  const isPayloadEmpty = (payload: any): boolean => {
    if (!payload) return true;
    const values = Object.values(payload);
    if (values.length === 0) return true;
    return values.every((val) => {
      if (val === null || val === undefined || val === "") return true;
      if (Array.isArray(val) && val.length === 0) return true;
      if (typeof val === "string" && val.trim() === "") return true;
      return false;
    });
  };

  const callAICompliance = async (
    contextName: string,
    payload: any,
    sendPayload?: any,
  ) => {
    if (
      !payload ||
      contextName === "" ||
      contextName === "AI Companion" ||
      isPayloadEmpty(payload)
    ) {
      return;
    }
    try {
      setAIloading(true);
      const newAccumulated = { ...accumulatedAIPayload, ...payload };
      setAccumulatedAIPayload(newAccumulated);
      const dataToSend = sendPayload || newAccumulated;
      setAiContextHistory((prev) => [
        ...prev,
        { contextName, payload: dataToSend },
      ]);
      const response = await getAIcomplaince(contextName, dataToSend);
      setaiobservation(response || []);
      setaiSuggestion(response || []);
    } catch (err) {
      console.error("AI Companion Error:", err);
    } finally {
      setAIloading(false);
    }
  };

  const updateAuditeeInfo = (
    field: keyof AuditData["auditeeInfo"],
    value: any,
  ) => {
    if (field === "organizations" && Array.isArray(value)) {
      const formattedAuditeeInfo = value.map((item: any) => ({
        orgId: item.organizationId,
        applicationId: item.applicationId || [],
        auditeeMembers: (item.members || []).map((m: any) => ({
          memberId: m.memberId,
          role: "Member",
        })),
        auditeeTeamLead: (item.teamLead || []).map((m: any) => ({
          memberId: m.memberId,
          role: "Lead",
        })),
      }));
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          organizations: value.map((item: any) => item.organizationId),
          auditeeTeamLead: value.map((item: any) => item.teamLead),
          emails: value.map((item: any) => item.members),
          applicationID: value.map((item: any) => item.applicationId),
          applicationName: value.map((item: any) => item.name),
          applicationType: value.map((item: any) => item.type),
          organizationdetail: value,
          organizationDetailsData: formattedAuditeeInfo,
        },
      }));
      if (value.length > 0) {
        const orgPayload = value.map((item: any) => ({
          organization: item.organizationName || item.name,
          application: item.applicationName,
          auditee_lead: (item.teamLead || [])
            .map((t: any) => t.name)
            .join(", "),
          auditee_member: (item.members || [])
            .map((m: any) => m.name)
            .join(", "),
        }));
        const previousOrgs = accumulatedAIPayload.organization || [];
        const newOrgs = orgPayload.filter(
          (org: any) =>
            !previousOrgs.some(
              (prev: any) => prev.organization === org.organization,
            ),
        );
        callAICompliance(
          "organizations-applications",
          { organization: orgPayload },
          { organization: newOrgs.length > 0 ? newOrgs : orgPayload },
        );
      }
      return;
    }

    if (field === "auditThemes" && Array.isArray(value)) {
      const themeNames = value.map((item: any) => item.themeName);
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          auditThemes: value.map((item: any) => item.themeId),
          auditThemeNames: value.map((item: any) => item.themeName),
        },
      }));
      if (themeNames.length > 0) {
        callAICompliance("theme", { theme: themeNames.join(", ") });
      }
      return;
    }
    if (field === "sequencedata") {
      // Check if value already has the full payload structure (from Step2AuditTheme)
      const isFullPayload =
        value.length > 0 &&
        Object.prototype.hasOwnProperty.call(
          value[0],
          "questionValidationRequired",
        ) &&
        Object.prototype.hasOwnProperty.call(
          value[0],
          "responseValidationRequired",
        );

      if (isFullPayload) {
        // Value is already in the correct format from Step2AuditTheme
        setAuditData((prev) => ({
          ...prev,
          auditeeInfo: {
            ...prev.auditeeInfo,
            sequencedata: value,
          },
        }));
      } else {
        // Legacy format: transform it
        setCustomSequenceOrder(value);

        const result = value.map((item: any, index: any) => ({
          sequenceId: item.sequenceId,
          sequenceOrder: index + 1,
        }));
        setAuditData((prev) => ({
          ...prev,
          auditeeInfo: {
            ...prev.auditeeInfo,
            sequencedata: result,
          },
        }));
      }
      return;
    }

    if (field === "members" && Array.isArray(value)) {
      setAuditData((prev) => ({
        ...prev,
        auditeeInfo: {
          ...prev.auditeeInfo,
          members: value.map((item: any) => item.value),
          membersname: value.map((item: any) => item.label),
          membersmail: value.map((item: any) => item.email),
        },
      }));
      if (value.length > 0) {
        const memberEmails = value.map((item: any) => item.label).join(", ");
        callAICompliance("auditor", { auditor: memberEmails });
      }
      return;
    }

    setAuditData((prev) => ({
      ...prev,
      auditeeInfo: { ...prev.auditeeInfo, [field]: value },
    }));
  };

  const validateStep1 = () => {
    const orgDetails = auditData.auditeeInfo.organizationdetail;

    // Must have at least one organization
    if (!orgDetails || orgDetails.length === 0) return false;

    // Validate each organization
    for (const org of orgDetails) {
      if (!org.organizationId || !org.name || !org.type) return false;
      if (!org.members || org.members.length === 0) return false;
    }

    return true;
  };

  const validateStep2 = () => {
    const { auditeeInfo } = auditData;
    const errors: Record<string, string> = {};

    const themeNames = (auditeeInfo as any).auditThemeNames;

    // 1️⃣ Validate that at least one theme is selected
    if (!auditeeInfo.auditThemes || auditeeInfo.auditThemes.length === 0) {
      errors.auditThemes = "Please select at least one audit theme.";
    }

    // 2️⃣ Validate theme name mapping count
    if (themeNames && themeNames.length !== auditeeInfo.auditThemes.length) {
      errors.auditThemeNames = "Mismatch between selected theme IDs and names.";
    }

    // 3️⃣ Validate that theme names are not empty
    if (themeNames && themeNames.some((name: string) => !name.trim())) {
      errors.auditThemeNames = "Theme names cannot be empty.";
    }

    // 4️⃣ Return result
    if (Object.keys(errors).length > 0) {
      console.error("Step 2 validation failed:", errors);
      return false;
    }

    return true;
  };

  const validateStep3 = () => {
    const { auditeeInfo } = auditData;
    const errors: Record<string, string> = {};

    const members = auditeeInfo.members || [];
    const memberNames = (auditeeInfo as any).membersname || [];
    const memberMails = (auditeeInfo as any).membersmail || [];

    // 1️⃣ Check that at least one member is selected
    if (members.length === 0) {
      errors.members = "Please select at least one auditee member.";
    }

    // 2️⃣ Check that all arrays have matching counts
    if (
      members.length !== memberNames.length ||
      members.length !== memberMails.length
    ) {
      errors.members = "Mismatch between member IDs, names, or emails.";
    }

    // 3️⃣ Check for empty or invalid values
    if (memberNames.some((name: string) => !name.trim())) {
      errors.membersname = "Member names cannot be empty.";
    }

    // 4️⃣ Return result
    if (Object.keys(errors).length > 0) {
      console.error("Step 3 validation failed:", errors);
      return false;
    }

    return true;
  };

  const validateStep4 = () => {
    if (
      auditData.auditeeInfo.startDate.getTime() ===
      auditData.auditeeInfo.startDateMarker.getTime()
    )
      return false;
    if (
      auditData.auditeeInfo.endDate.getTime() ===
      auditData.auditeeInfo.endDateMarker.getTime()
    )
      return false;
    if (auditData.auditLevel === 0) return false;
    if (auditData.auditSla === 0) return false;
    if (auditData.escalationDay === 0) return false;
    if (
      !auditData.auditeeInfo.sequencedata ||
      auditData.auditeeInfo.sequencedata.length === 0
    )
      return false;

    // Response time must be less than audit duration
    const start = new Date(auditData.auditeeInfo.startDate);
    const end = new Date(auditData.auditeeInfo.endDate);
    if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
      const durationDays = Math.ceil(
        (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24),
      );
      if (auditData.auditSla >= durationDays) return false;
    }

    return true;
  };
  const nextDisable =
    (currentStep === 1 && !validateStep1()) ||
    (currentStep === 2 && !validateStep2()) ||
    (currentStep === 3 && !validateStep3()) ||
    (currentStep === 4 && !validateStep4());

  const nextStep = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    let isValid = true;

    switch (currentStep) {
      case 1:
        isValid = validateStep1();
        break;
      case 2:
        isValid = validateStep2();
        break;
      case 3:
        isValid = validateStep3();
        break;
      case 4:
        isValid = validateStep4();
        break;
      default:
        isValid = true;
        break;
    }

    if (!isValid) {
      setValidated(true);
      return;
    }
    setValidated(false);
    if (currentStep < 5) setCurrentStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) setCurrentStep(currentStep - 1);
  };

  const handleSubmit = () => {
    dispatch(setSelectedThemes([]));
    dispatch(setSelectedMembers([]));
    dispatch(setMappedBanksvalues([]));
    onSubmit(auditData);
    setSubmitClicked(true);
  };
  const handleChangeMembers = (selectValue: any[]) => {
    setAuditMembers(selectValue);
    const memberSet: string[] = [];
    const memberOptions: AuditOption[] = [];
    membersList.map((res: AuditOption) => {
      if (selectValue.includes(res.value as never)) {
        memberSet.push(res.label);
        memberOptions.push(res);
      }
    });
    setTeamMembersDisplay(memberSet);
    setSelectedMembersOption(memberOptions);
    setAuditData((prev) => ({
      ...prev,
      teamMembers: selectValue,
    }));
  };
  const onMembersChange = (selectValue: any[]) => {
    setAuditMembers(selectValue?.map((data) => data?.value));
    const memberSet: string[] = [];
    const memberOptions: AuditOption[] = [];
    selectValue.forEach((res: AuditOption) => {
      memberSet.push(res.label);
      memberOptions.push(res);
    });
    setTeamMembersDisplay(memberSet);
    setSelectedMembersOption(memberOptions);
    setAuditData((prev) => ({
      ...prev,
      teamMembers: selectValue,
    }));
  };

  interface StatusDotProps {
    color: string; // Accepts any valid CSS color value
    size?: number; // Optional size prop (default: 10px)
  }
  const statusColorMap: Record<string, string> = {
    Shallow: "green",
    Descriptive: "#a6b92b",
    Moderate: "#fec107",
    Deeper: "#f8811e",
    Deepest: "red",
  };
  const StatusDot: React.FC<StatusDotProps> = ({ color, size = 10 }) => {
    return (
      <div
        style={{
          width: `${size}px`,
          height: `${size}px`,
          backgroundColor: color,
          borderRadius: "50%",
          display: "inline-block",
          marginBottom: "-2px",
        }}
      />
    );
  };

  const onDateChange = (startDate: any, endDate: any) => {
    const convertedStartDate = parseDate(startDate); // "01-07-2025"
    const convertedEndDate = parseDate(endDate);
    setAuditData((prev) => ({
      ...prev,
      auditeeInfo: {
        ...prev.auditeeInfo,
        startDate: convertedStartDate,
        endDate: convertedEndDate,
      },
    }));
  };
  useEffect(() => {
    if (currentStep === 4 && auditData.auditLevel) {
      callAICompliance("audit_level", {
        audit_level: `${AUDIT_LEVEL[auditData.auditLevel as any]}(${auditData.auditLevel})`,
      });
    }
  }, [auditData.auditLevel]);
  const handleRemainderCall = () => {
    if (auditData.escalationDay) {
      callAICompliance("reminder_alert", {
        reminder_alert: `${auditData.escalationDay} Day${auditData.escalationDay === 1 ? "" : "s"}`,
      });
    }
  };
  useEffect(() => {
    if (auditData.auditeeInfo.startDate && auditData.auditeeInfo.endDate) {
      const start = new Date(auditData.auditeeInfo.startDate)
        .toISOString()
        .split("T")[0];
      const end = new Date(auditData.auditeeInfo.endDate)
        .toISOString()
        .split("T")[0];
      if (start !== end) {
        const Days = getDaysDiff(
          auditData.auditeeInfo.startDate,
          auditData.auditeeInfo.endDate,
        );
        callAICompliance("duration", {
          duration: `${Days} Day${Days === 1 ? "" : "s"}`,
        });
      }
    }
  }, [auditData.auditeeInfo.endDate, auditData.auditeeInfo.startDate]);

  const handleTimeoutcall = () => {
    if (auditData.auditSla) {
      callAICompliance("response_time", {
        response_time: `${auditData.auditSla} Day${auditData.auditSla === 1 ? "" : "s"}`,
      });
    }
  };
  const handleDatechangeAPICall = (e: React.FocusEvent<HTMLInputElement>) => {
    /* noop */
  };
  const isInValidDuration =
    auditData.auditeeInfo.startDate?.getTime() ===
      auditData.auditeeInfo.startDateMarker?.getTime() ||
    auditData.auditeeInfo.endDate.getTime() ===
      auditData.auditeeInfo.endDateMarker.getTime();

  const renderStepContent = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            banks={getOrganization}
            updateAuditeeInfo={updateAuditeeInfo}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
          />
        );

      case 2:
        return (
          <Step2
            sourceItems={getTheme}
            destinationItems={getTheme.length}
            auditeesList={auditeesList}
            updateAuditeeInfo={updateAuditeeInfo}
            auditData={auditData}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
            auditUpdatedata={auditUpdatedata}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
          />
        );

      case 3:
        return (
          <Step3
            auditUpdatedata={auditUpdatedata}
            destinationItems={membersList.length}
            updateAuditeeInfo={updateAuditeeInfo}
            auditMembers={auditMembers}
            membersList={membersList}
            selectedMembersOption={selectedMembersOption}
            validated={validated}
            userData={userData}
            auditData={auditData}
            setAuditData={setAuditData}
            handleChangeMembers={handleChangeMembers}
            onMembersChange={onMembersChange}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
          />
        );

      case 4:
        return (
          <Step4
            checked={checked}
            handleToggle={handleToggle}
            updateAuditeeInfo={updateAuditeeInfo}
            isInValidDuration={isInValidDuration}
            onDateChange={onDateChange}
            auditUpdatedata={auditUpdatedata}
            handleDatechangeAPICall={handleDatechangeAPICall}
            validated={validated}
            setAuditData={setAuditData}
            auditData={auditData}
            setShowAISuggestion={setShowAISuggestion}
            aiSuggestion={aiSuggestion}
            showAISuggestion={showAISuggestion}
            AIloading={AIloading}
            setShowAICompanion={setShowAICompanion}
            showAICompanion={showAICompanion}
            handleTimeoutcall={handleTimeoutcall}
            handleRemainderCall={handleRemainderCall}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
            sequenceMode={sequenceMode}
            setSequenceMode={setSequenceMode}
          />
        );
      case 5:
        return (
          <Step5
            statusColorMap={statusColorMap}
            auditData={auditData}
            teamMembersDisplay={teamMembersDisplay}
            auditeeDisplay={auditeeDisplay}
            StatusDot={StatusDot}
            userData={userData}
            sequence={
              customSequenceOrder.length > 0 ? customSequenceOrder : sequence
            }
          />
        );

      default:
    }
  };

  const breadcrumbItems = [
    {
      label: "Audits Lists",
      path: "/audit-overview",
    },
    {
      label:
        "Create Audit Plan" +
        (auditUpdatedata?.auditCode ? ` (${auditUpdatedata.auditCode})` : ""),
    },
  ];

  return (
    <CreateAudit
      Heading={"Create Audit Plan"}
      loading={loading}
      setShowConfirm={setShowConfirm}
      renderStepContent={renderStepContent}
      steps={steps}
      nextStep={nextStep}
      prevStep={prevStep}
      currentStep={currentStep}
      handleSubmit={handleSubmit}
      nextDisable={nextDisable}
      submitClicked={submitClicked}
      showConfirm={showConfirm}
      showToast={showToast}
      aiSuggestion={aiSuggestion}
      showAISuggestion={showAISuggestion}
      setShowAISuggestion={setShowAISuggestion}
      setShowAIobservation={setShowAIobservation}
      showAItooltip={showAItooltip}
      setShowAItooltip={setShowAItooltip}
      AIloading={AIloading}
      setShowAICompanion={setShowAICompanion}
      showAICompanion={showAICompanion}
      userData={userData}
      aiContextHistory={aiContextHistory}
      breadcrumbItems={breadcrumbItems}
    />
  );
};

export default AuditRegistration;
